import collect from 'collect.js';

/**
 * Recursively removes empty arrays, empty objects, empty strings,
 * null, undefined and false values from the specified object.
 *
 * @note Works for arrays too as an array has a typeof "object".
 *
 * @param {*} value
 * @return {*}
 */
export function cleanObject(value) {
    return typeof value === 'object'
        ? collect(value)
              .filter()
              .map((i) => cleanObject(i))
              .all()
        : value;
}
